import HeroSection from "./components/HeroSection";
import HotScoresBar from "./components/HotScoresBar";
import LiveMatchesSection from "./components/LiveMatchesSection";
import FeaturedSection from "./components/FeaturedSection";
import CategoryNav from "./components/CategoryNav";
import NewsSection from "./components/NewsSection";
import SEOHead from "@/components/feature/SEOHead";

export default function Home() {
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "极速体育",
    url: "https://www.jisusports.com/",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://www.jisusports.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  const webpageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "极速体育——实时赛事直播与体育资讯平台",
    description: "极速体育，为体育迷提供最快速的实时赛事直播、比分更新、体育资讯与赛事分析。",
    url: "https://www.jisusports.com/",
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "首页",
        item: "https://www.jisusports.com/",
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="极速体育——实时赛事直播与体育资讯平台"
        description="极速体育，为体育迷提供最快速的实时赛事直播、比分更新、体育资讯与赛事分析。足球、篮球、网球等全项目覆盖，极速体育让你零延迟感受每一个精彩瞬间，随时随地掌握赛场动态。"
        keywords="极速体育,极速体育直播,极速体育实时比分,极速体育赛事资讯,极速体育足球直播,极速体育篮球比赛,体育赛事实时更新"
        canonicalUrl="https://www.jisusports.com/"
        structuredData={{ ...websiteSchema, ...webpageSchema, ...breadcrumbSchema }}
      />

      <main>
        <HeroSection />
        <HotScoresBar />
        <LiveMatchesSection />
        <FeaturedSection />
        <CategoryNav />
        <NewsSection />
      </main>
    </>
  );
}